import { render } from "./duanqi_roster.vue?vue&type=template&id=11698e82&scoped=true"
import script from "./duanqi_roster.vue?vue&type=script&lang=js"
export * from "./duanqi_roster.vue?vue&type=script&lang=js"

import "./duanqi_roster.vue?vue&type=style&index=0&id=11698e82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11698e82"]])

export default __exports__